import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { DisclaimerNoteProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { useSelector } from 'react-redux';
import { getStore } from '~/store/reducers/purchase/purchase';

export const DisclaimerNote = styled(({ className }: DisclaimerNoteProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'welcome_view' });
  const { purchaseInfo } = useSelector(getStore);

  return (
    <p className={className}>
      {(purchaseInfo.amountRequested && purchaseInfo.roNumber ? '*' : '') + t('disclaimer_note')}
    </p>
  );
})`
  ${styles.DisclaimerNote}
`;
